import React, { useEffect, useState } from "react";
import { Button, Card, Divider, Form, Input, Typography } from "antd";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import toast from "react-hot-toast";
import { changeLoader } from "../../redux/reducers/loader";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { checkPermissionAction } from "../../utils/helper/utils";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const SystemSettings = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  let [permissionJson, setPermissionJson] = useState([]);

  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(
      storageKeys?.USER_TOKEN,
      {},
      "get"
    );
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
      setPermissionJson(permissionJson);
    }
    if (!checkPermissionAction("System Settings", permissionJson, "view")) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const handleSubmit = async (values) => {
    dispatch(changeLoader(true));
    try {
      let url = Apis?.SYSTEM_SETTING?.UPDATE_SETTING + "/1";
      let method = "put";
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "System setting updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getSystemSettingDetail = async () => {
    try {
      let response = await globalRequest(
        Apis.SYSTEM_SETTING.GET_SETTING_DETAIL + "/1",
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        // form.setFieldValue(
        //   "fastest_delivery_loading_time",
        //   data?.fastestDeliveryLoadingTime
        // );
        // form.setFieldValue(
        //   "schedule_delivery_loading_time",
        //   data?.scheduleDeliveryLoadingTime
        // );
        // form.setFieldValue("fastest_buffer_time", data?.fastestBufferTime);
        // form.setFieldValue("schedule_buffer_time", data?.scheduleBufferTime);
        form.setFieldValue("platform_fees", data?.platformFees);
        form.setFieldValue("vendor_deduction", data?.vendorDeduction);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    getSystemSettingDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Card>
        <Typography className="text-xl font-semibold" align={"left"}>
          Update setting Data
        </Typography>
        <Divider />
        <div className="min-h-[calc(100vh_-_305px)]">
          <Form
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
            style={{
              maxWidth: 600,
              width: "100%",
            }}
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
          >
            {/* <Form.Item
              label="Loading time for fastest delivery"
              name="fastest_delivery_loading_time"
              rules={[
                {
                  required: true,
                  message:
                    "Please enter your Loading time for fastest delivery.",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve(); // Skip further validation if required fails
                    }
                    // Ensure the value is a number and validate it
                    if (Number(value) > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Please provide a value greater than zero.")
                    );
                  },
                },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue(
                    "fastest_delivery_loading_time",
                    value.trimStart()
                  );
                  handleInputChange("fastest_delivery_loading_time");
                }}
                addonAfter={<span>min</span>}
              />
            </Form.Item>
            <Form.Item
              label="Loading time for scheduled delivery"
              name="schedule_delivery_loading_time"
              rules={[
                {
                  required: true,
                  message:
                    "Please enter your Loading time for scheduled delivery.",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve(); // Skip further validation if required fails
                    }
                    // Ensure the value is a number and validate it
                    if (Number(value) > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Please provide a value greater than zero.")
                    );
                  },
                },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue(
                    "schedule_delivery_loading_time",
                    value.trimStart()
                  );
                  handleInputChange("schedule_delivery_loading_time");
                }}
                addonAfter={<span>min</span>}
              />
            </Form.Item>
            <Form.Item
              label="Buffer time for fastest delivery"
              name="fastest_buffer_time"
              rules={[
                {
                  required: true,
                  message:
                    "Please enter your Buffer time for fastest delivery.",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve(); // Skip further validation if required fails
                    }
                    // Ensure the value is a number and validate it
                    if (Number(value) > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Please provide a value greater than zero.")
                    );
                  },
                },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue("fastest_buffer_time", value.trimStart());
                  handleInputChange("fastest_buffer_time");
                }}
                addonAfter={<span>min</span>}
              />
            </Form.Item>
            <Form.Item
              label="Buffer time for scheduled delivery"
              name="schedule_buffer_time"
              rules={[
                {
                  required: true,
                  message:
                    "Please enter your Buffer time for scheduled delivery.",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve(); // Skip further validation if required fails
                    }
                    // Ensure the value is a number and validate it
                    if (Number(value) > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Please provide a value greater than zero.")
                    );
                  },
                },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue("schedule_buffer_time", value.trimStart());
                  handleInputChange("schedule_buffer_time");
                }}
                addonAfter={<span>min</span>}
              />
            </Form.Item> */}

            <Form.Item
              label="Platform fees"
              name="platform_fees"
              rules={[
                {
                  required: true,
                  message: "Please enter your Platform fees Percent.",
                },
                {
                  validator: (_, value) => {
                    if (value && Number(value) > 100) {
                      return Promise.reject(new Error("Platform fees percent cannot exceed 100"));
                    }
                    return Promise.resolve();
                  },
                },
                // {
                //   validator: (_, value) => {
                //     if (!value) {
                //       return Promise.resolve(); // Skip further validation if required fails
                //     }
                //     // Ensure the value is a number and validate it
                //     if (Number(value) > 0) {
                //       return Promise.resolve();
                //     }
                //     return Promise.reject(
                //       new Error("Please provide a value greater than zero.")
                //     );
                //   },
                // },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "float");
                  form.setFieldValue("platform_fees", value.trimStart());
                  handleInputChange("platform_fees");
                }}
                addonAfter={<span>%</span>}
              />
              {/* addonAfter={<span>%</span>} */}
            </Form.Item>

            {/* <Form.Item
              label="Vendor deduction"
              name="vendor_deduction"
              rules={[
                {
                  required: true,
                  message: "Please enter your vendor deduction.",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve();
                    }                    
                    if (Number(value) > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Please provide a value greater than zero.")
                    );
                  },
                },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "float");
                  form.setFieldValue("vendor_deduction", value.trimStart());
                  handleInputChange("vendor_deduction");
                }}
              />              
            </Form.Item> */}
          </Form>
        </div>
        <Divider />
        <div className="flex justify-end gap-3">
          {checkPermissionAction("System Settings", permissionJson, "edit") ? (
            <>
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => form.submit()}
              >
                Save
              </Button>
            </>
          ) : null}
        </div>
      </Card>
    </>
  );
};
export default SystemSettings;
